// @ts-nocheck
import { ProductCarouselProductStyles } from "@store/Overrides/Components/ProductCarouselProduct";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductPartNumbers from "@store/Overrides/Components/ProductPartNumbers";
import ProductPrice from "@store/Overrides/Components/ProductPrice";
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { CartLineContext } from "@insite/client-framework/Components/CartLineContext";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription from "@insite/content-library/Components/ProductDescription";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import ArrowiOSUpward from "@store/Library/Components/Toolkit/Icons/ArrowiOSUpward";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { productCardProps } from "@store/Themes/common/props/productCard";
import displaySndProducts from "@store/Framework/Store/Store/Data/Products/Handlers/DisplaySndProducts";
import { carouselProps } from "@store/Themes/common/props/carousel";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useProductsDataView } from "@toolkit/Framework/Store/Data/Products/ProductsHooks";
import { useEmblaCarousel } from "embla-carousel/react";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

interface OwnProps extends WidgetProps {
    forCartLines?: boolean;
}

const mapStateToProps = (state: ApplicationState, ownProps: WidgetProps) => {
    const { userName } = state.context.session;
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    return {
        state,
        productInfoByProductId:
            state.components.productInfoLists.productInfoListById[ownProps.id]?.productInfoByProductId,
        isSignedIn: userName && !currentUserIsGuest,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ThemeProps<BaseTheme>;

export interface ScratchAndDentParentProductStyles {
    widgeTitle?: TypographyProps;
    productImageStyles?: ProductImageStyles;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowButton?: ButtonPresentationProps;
    prevArrowWrapper?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    dotsWrapper?: InjectableCss;
    dotButton?: ButtonPresentationProps;
    dotButtonSelected?: ButtonPresentationProps;
    link?: LinkPresentationProps;
}

export const scratchAndDentParentProductStyles: ScratchAndDentParentProductStyles = {
    widgeTitle: {
        variant: "h2",
        as: "strong",
        color: "primary",
        css: css`
            display: block;
        `,
    },
    prevArrowWrapper: carouselProps.prevArrowWrapper,
    prevArrowButton: carouselProps.prevArrowButton,
    nextArrowWrapper: carouselProps.nextArrowWrapper,
    nextArrowButton: carouselProps.nextArrowButton,
    carouselWrapper: carouselProps.carouselWrapper,
    carouselContainer: {
        css: css`
            overflow: hidden;
            width: 100%;

            &::after {
                content: "";
                width: 4em;
                height: 100%;
                top: 0;
                right: -1em;
                background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
                display: block;
                bottom: 0;
                position: absolute;
            }
        `,
    },
    carouselSlidesContainer: {
        css: css`
            ${carouselProps.carouselSlidesContainer?.css}
            margin: ${pxToRem(0)};
        `,
    },
    carouselSlide: {
        css: css`
            position: relative;
            flex: 0 0 auto;
            margin: ${pxToRem(0, 7.5)};
            width: 65%;
            border: 1px solid ${getColor("common.border")};
            display: flex;
            > div {
                padding: ${pxToRem(15)};
            }
            > div:first-child {
                flex: 1;
                padding-right: 0;
            }
            > div:last-child {
                flex: 2;
            }
        `,
    },
    carouselSlideInner: productCardProps.card,
    dotsWrapper: carouselProps.dotsWrapper,
    dotButton: carouselProps.dotButton,
    dotButtonSelected: carouselProps.dotButtonSelected,
    link: linkGetActionLinkProps(ArrowiOSDownward, "right"),
};

const styles = scratchAndDentParentProductStyles;
const ScratchAndDentParentProduct = ({ id, theme, state, forCartLines, productInfoByProductId, isSignedIn }: Props) => {
    const dispatch = useDispatch();
    const { product } = useContext(ProductContext);
    const cartLine = useContext(CartLineContext);
    const [showSndProds, setShowSndProds] = useState(false);
    const showSndClickHandler = () => {
        setShowSndProds(!showSndProds);
    };

    const customLinkCss = mergeProps<ScratchAndDentParentProductStyles["link"]>(
        styles.link,
        showSndProds
            ? linkGetActionLinkProps(ArrowiOSUpward, "right")
            : linkGetActionLinkProps(ArrowiOSDownward, "right"),
    );

    let sku = "";
    if (product) {
        sku = product.productNumber;
    } else if (cartLine) {
        sku = cartLine.erpNumber;
    }

    const parameters = useMemo(() => {
        return { productIds: [sku], apiType: "snd", widgetId: id };
    }, [sku]);
    const productsDataView = useProductsDataView(parameters);

    const products = productsDataView.value;
    const productInfos = getMatchingDataFromDictionary(products, productInfoByProductId);
    const trackViewItemList = ga.use.trackViewItemList(
        { items: products, item_list_name: "Save big with scratch and dents products", item_list_id: "sndCarousel" },
        { productInfos },
    );
    ga.use.productInfosCallback(productInfos, trackViewItemList, undefined, !isSignedIn);

    useEffect(() => {
        if (!productsDataView.value && !productsDataView.isLoading) {
            dispatch(displaySndProducts(parameters));
        }
    }, [parameters]);
    const [emblaRef, embla] = useEmblaCarousel();
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const setCanScroll = () => {
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };
    const [slidesToScroll] = useState(1);

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", () => {
            setCanScroll();
            setSelectedIndex(embla.selectedScrollSnap());
        });
    }, [embla]);

    useEffect(() => {
        const products = productsDataView.value;
        if (!embla || !products || products.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll: 1,
            draggable: isTouchDevice(),
            loop: products.length > slidesToScroll,
        });
    }, [embla, parameters, productsDataView.value]);

    if (!productsDataView || productsDataView?.value?.length === 0) {
        return null;
    }
    if (!products || !products.length) {
        return null;
    }
    if (!sku) {
        return null;
    }
    const dotCount = Math.ceil(products!.length / slidesToScroll);
    const getDots = () => {
        const dots = [];

        for (let i = 0; i < dotCount; i++) {
            dots.push(
                <Button
                    key={i} // eslint-disable-line react/no-array-index-key
                    {...(i === selectedIndex ? styles.dotButtonSelected : styles.dotButton)}
                    aria-current={i === selectedIndex}
                    onClick={() => embla && embla.scrollTo(i)}
                >
                    <VisuallyHidden>{translate("Go to slide {0} of {1}", `${i + 1}`, `${dotCount}`)}</VisuallyHidden>
                </Button>,
            );
        }

        return <StyledWrapper {...styles.dotsWrapper}>{dots}</StyledWrapper>;
    };

    const carouselContent = (
        <>
            <StyledWrapper {...styles.carouselWrapper}>
                {products.length > slidesToScroll && (
                    <StyledWrapper {...styles.prevArrowWrapper}>
                        <Button
                            {...styles.prevArrowButton}
                            onClick={() => embla && embla.scrollPrev()}
                            disabled={!canScrollPrev}
                            data-test-selector="prevBtn"
                        >
                            <VisuallyHidden>{translate("Previous slide")}</VisuallyHidden>
                        </Button>
                    </StyledWrapper>
                )}
                <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                    <StyledWrapper {...styles.carouselSlidesContainer}>
                        {products.map(product => {
                            const productContext: ProductContextModel = {
                                product,
                                productInfo:
                                    getProductInfoFromList(state, id, product.id) || createFromProduct(product),
                            };

                            const textBadges = product.badges?.filter(
                                o => o.displayOnBadgeWidget && o.badgeType === BadgeTypeValues.Text && o.displayText,
                            );

                            return (
                                <StyledWrapper {...styles.carouselSlide} id={`product_${product.id}`} key={product.id}>
                                    <StyledWrapper>
                                        <ProductImage
                                            product={productContext}
                                            extendedStyles={styles.productImageStyles}
                                            size="medium"
                                        />
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        <ProductContext.Provider
                                            value={productContext}
                                            key={`${product.id}-snd-inventory`}
                                        >
                                            <ProductDescription product={productContext} />
                                            {textBadges && <ProductTextBadges badgeList={textBadges} maxBadges={4} />}
                                            <ProductPartNumbers
                                                productNumber={product.productNumber}
                                                customerProductNumber={product.customerProductNumber}
                                                manufacturerItem={product.manufacturerItem}
                                                showCustomerName={false}
                                                showManufacturerItem={false}
                                            />
                                            <ProductPrice showLabel={false} product={productContext} />
                                            <ProductContextAvailability />
                                        </ProductContext.Provider>
                                    </StyledWrapper>
                                </StyledWrapper>
                            );
                        })}
                    </StyledWrapper>
                </StyledWrapper>
                {products.length > slidesToScroll ? (
                    <StyledWrapper {...styles.nextArrowWrapper}>
                        <Button
                            {...styles.nextArrowButton}
                            onClick={() => embla && embla.scrollNext()}
                            disabled={!canScrollNext}
                            data-test-selector="nextBtn"
                        >
                            <VisuallyHidden>{translate("Next slide")}</VisuallyHidden>
                        </Button>
                    </StyledWrapper>
                ) : null}
            </StyledWrapper>
            {dotCount > 1 ? getDots() : null /* Starter Custom Code */}
        </>
    );

    return (
        <StyledWrapper>
            {forCartLines ? (
                <>
                    <Link
                        {...customLinkCss}
                        onClick={showSndClickHandler}
                        data-test-selector="cartline_sndRecommendations"
                    >
                        {`${translate("Save big with scratch and dents products")} (${products.length})`}
                    </Link>
                    {showSndProds && carouselContent}
                </>
            ) : (
                <>
                    <Typography {...styles.widgeTitle}>
                        {translate("Save big with scratch and dents products")}
                    </Typography>
                    {carouselContent}
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withTheme(ScratchAndDentParentProduct)),
    definition: {
        displayName: "Scratch And Dent Parent Product Widget",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
